module.exports = __webpack_public_path__ + "img/audio-file-icon.0656855a.svg";